import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';

import { useApiContext } from 'context/ApiContext';
import { useGlobalContext } from 'context/GlobalContext';
import { KEYS } from 'helpers/react-query.config';
import { AxiosServiceError } from 'interfaces/general';

interface Props {
  ticketId?: string;
  enabled?: boolean;
  taskForces?: boolean;
  actualTaskForce?: number;
}

const useGeneralChangeStatusServices = ({
  ticketId,
  enabled = true,
  taskForces = false,
  actualTaskForce
}: Props = {}) => {
  const { showApiError } = useGlobalContext();
  const { ticket: ticketApi } = useApiContext();
  const { t } = useTranslation('global');

  const getTicketDetail = useQuery(
    KEYS.ticket.tickets.detail(Number(ticketId)),
    () => ticketApi.tickets.detail(Number(ticketId)),
    {
      select: ({ data }) => data?.data,
      refetchOnWindowFocus: false,
      enabled: !!ticketId && enabled,
      onSuccess: (data) => {
        if (!data?.ticketStatusId || !Object.keys(data).length) {
          showApiError('', t('errorMessages.ticketDetails'));
        }
      },
      onError: (error) => showApiError(error, t('errorMessages.ticketDetails'))
    }
  );

  const getTaskForces = useQuery(
    [KEYS.ticket.assignations.getAssignableTaskForceByTicketsId([ticketId])],
    () =>
      ticketApi.assignations.getAssignableTaskForceByTicketsId({
        ticketsId: [ticketId],
        assignedTaskForceId: actualTaskForce
      }),
    {
      select: (data) => data?.data?.data,
      enabled: !!ticketId && taskForces,
      onError: (error: AxiosServiceError) =>
        showApiError(error, t('errorMessages.taskForce')),
      refetchOnWindowFocus: false
    }
  );

  return {
    getTicketDetail,
    getTaskForces
  };
};

export default useGeneralChangeStatusServices;
